'use strict'

// Displays an animated loader to show the widget is working and not just frozen.
cpntMap.set('awe-loader', {
  props: {
    type: {type: String, default:''},
    hasOverlay: {type: Boolean, default: true},
    delay: {type: Number, default: 800} // delay to observe before showing when loader is activated. Set to 0 to disable
  },
  data: function(){
    return {
      visible: false, // whether the loader is visible
      _itvId: 0, // id of the timeout used to delay showing the loader
      // counter: number of current show requests. Decremented with each call to hide. Hide is performed only if counter is 0.
      // This avoids sync issue where 2 show requests are hidden by the first hide request.
      // A request is still in progress and loader should show until 2nd hide request is made:
      // 1: show: do it
      // 2: show: already done
      // 3: hide: don't hide, request is still in progress
      // 4: hide: hide loader
      counter: 0
    }
  },
  
  mounted: function(){
    setTimeout(() => {
      this.$root.addEventListener('loader-show', (e) => {
        if (e.detail.type === this.type){
          this.show(e.detail.delay)
        }
      })
      this.$root.addEventListener('loader-hide', (e) => {
        // console.debug('loader-hide', e.detail.type)
        if (e.detail.type === this.type){
          this.hide()
        }
      })
  })
  },
  methods: {

    // shows loader
    // delay (integer): overwrites the loader delay
    show: function(delay){
      if (delay == null)
        delay = this.delay

      this.counter++
      // console.debug(`show loader ${this.counter} [${Date.now()}]`)
      if (this.visible) return

      if (delay === 0)
        this.visible = true
      else{
        clearTimeout(this._itvId) // clear existing timeout before setting a new one
        this._itvId = setTimeout(() => {
          // console.debug(`loader visible [${Date.now()}]`)
          this.visible = true
        }, delay)
      }
    },

    // hides loader
    hide: function(){
      // console.log('hide loader ' + this.counter)

      // hideLoader can be called more times than showLoader (in case of duplicate product request). Don't allow counter to  be negative should fix the loader issue.
      this.counter = Math.max(0, this.counter - 1)

      if (this.counter <= 0){
        this.visible = false

        // clears timeout, to not show loader in case the request resolves before the show delay ends.
        clearTimeout(this._itvId)
      }
    }
  },

  template: `
    <transition name="fade" :duration="{enter: 1000, leave: 400}">
      <div v-show="visible" class="loader" role="presentation">
        <div v-if="hasOverlay" class="loader-overlay" role="presentation"></div>
        <slot>
          <span class="spinner " role="presentation">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </span>
        </slot>
      </div>
    </transition>
  `
})
